import LocalizedStrings from 'react-localization';
import { de, en, es } from './translations'

let strings = new LocalizedStrings({ en, es, de });

export { strings };
